import React from "react";
import styled from "styled-components";

const Section = styled.section`
  padding: 3rem;
  line-height: 1.6;
  max-width: 1200px;
  margin: 0 auto; 
  color: ${({ theme }) => theme.text};
  background-color: ${({ theme }) => theme.background};

  h3 {
  color: ${({ theme }) => theme.text};
  }

  h4 {
    margin-top: 2rem;
    font-weight: bold;
    color: ${({ theme }) => theme.headerText};
  }

  p {
    margin-top: 1rem;
    white-space: pre-line;
    color: ${({ theme }) => theme.ParagraphText};
  }
`;

export default function TemplatesPage() {
  return (
    <Section>
        <h3>Production Lot Uploads: Managing Templates</h3>
      <article>
        <h4>How did we get here? What is the reason for a "template".</h4>

        <p>
          The Beef Cattle Survey data depends on uploading of spreadsheet data. Data sources other than direct entry
          can be problematic. Spreadsheet data needs to fit into the database. By "fit" it is meant the fields have
          to line up and be of the same data type. As well it may require a translation of text into an integer
          match the database structure lookup lists used.
        </p>

        <p>
          We have five different sites providing spreadsheet data. All of the sites are to follow strict protocols
          how the spreadsheet should be setup. It will not happen. We have already seen it is the case. So we have
          developed a mechanism to upload a spreadsheet of data, then check structure and then match fields in the
          database.
        </p>

        <p>
          Template management is where we setup a template for a specific site or data source and describe how the
          spreadsheet data is to be interpreted when uploaded into the database.
        </p>

        <h4>Template: A Summary</h4>

        <p>
          A template is a list of columns which describes db strucutures for data we want loaded into the production
          databases.
        </p>

        <p>
          Each template represents one and only one drug route: bolus, feed or injectable.
        </p>

        <p>
          Each template can apply to one or more spreadsheets of data to be uploaded.
        </p>

        <p>
          A spreadsheet can be selected to check against a template to make sure the data matches what we can use in
          production.
        </p>

        <p>
          Once a template is setup you will be able to check if a new template meets the requirements for use.
        </p>

        <p>
          Templates are necessary when the final upload of data occurs into the production database.
        </p>

        <p>
          Templating is how we provide a map from a sites spreadsheet of data into our standardized data tables.
        </p>

        <h4>Who gets to setup templates?</h4>

        <p>
          Only users designated by Dr. Sheryl Gow as Project Managers will have access to Template Management.
        </p>

        <h4>How to begin?</h4>

        <p>
          Once the form opens go to "Select Group" drop down list. Pick a group. Remember a group is one or more veterinarians
          from a site providing the data. Once a group is selected then "Select Template". A template depends on the group.
          All templates are related to a specific group so don't be concerned. It is looked after.
        </p>

        <p>
          Once you have made your selections, click on the Get button. It is a little button below with a green top and
          an orange bottom. After getting the data you will see a list of fields for the template. 
        </p>

        <p>
          If you do not see a list of fields, we will describe to get an initial structure to populate your template.
        </p>

        <h4>How to add a new template name?</h4>

        <p>
          If you selected a group, the templates are listed you will need to add a new template. To do this click
          on the add button (+) just to the right of Select Template drop down list. A panel of information appears.
        </p>

        <p>
          Enter the new template name. Make it so you can recognize the group, year and drug route.
        </p>

        <p>
          Select a drug for the template.
        </p>

        <p>
          Please note when uploading a new spreadsheet of data do so for each group and separate out the different drug
          routes. There will be more instruction in the future how to upload spreadsheet data.
        </p>
      </article>
    </Section>
  );
}